/* eslint-disable */
export default {
  sureToDeleteVoiceMail: '이 음성 메일을 삭제하시겠습니까?',
  sureToDeleteFax: '팩스를 삭제하시겠습니까?',
  doNotAskAgain: '다시 묻지 않음',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
